import { Component, Input, ChangeDetectionStrategy } from '@angular/core'


@Component({
  selector: 'app-tax-note',
  templateUrl: './tax-note.component.html',
  styleUrl: './tax-note.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TaxNoteComponent {
  @Input() type!: 'brutto' | 'netto' | 'neutral'
}
